// Auth state: access token in memory only; refresh token lives in httpOnly cookie
// set by backend at login. Mirrors VR360 Tools admin auth pattern.

import { create } from 'zustand';

export type AdminRole = 'admin' | 'manager';

export interface AdminUser {
  id: string;
  username: string;
  role: AdminRole;
}

interface AuthState {
  user: AdminUser | null;
  accessToken: string | null;
  isHydrated: boolean;
  setAuth(user: AdminUser, accessToken: string): void;
  setAccessToken(accessToken: string): void;
  setUser(user: AdminUser | null): void;
  setHydrated(value: boolean): void;
  clear(): void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  isHydrated: false,
  setAuth: (user, accessToken) => set({ user, accessToken }),
  setAccessToken: (accessToken) => set({ accessToken }),
  setUser: (user) => set({ user }),
  setHydrated: (value) => set({ isHydrated: value }),
  clear: () => set({ user: null, accessToken: null }),
}));
